import React from 'react';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import './WhyCali.css';

// SVG Icons
const SunIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5"></circle>
    <line x1="12" y1="1" x2="12" y2="3"></line>
    <line x1="12" y1="21" x2="12" y2="23"></line>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
    <line x1="1" y1="12" x2="3" y2="12"></line>
    <line x1="21" y1="12" x2="23" y2="12"></line>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
  </svg>
);

const ForkKnifeIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"></path>
    <path d="M7 2v20"></path>
    <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"></path>
  </svg>
);

const MusicIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 18V5l12-2v13"></path>
    <circle cx="6" cy="18" r="3"></circle>
    <circle cx="18" cy="16" r="3"></circle>
  </svg>
);

const HeartOutlineIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
  </svg>
);

export default function WhyCali() {
  const { language } = useLanguage();
  const t = translations[language];

  const features = [
    {
      icon: <SunIcon />,
      title: t.climateTitle,
      desc: t.climateDesc
    },
    {
      icon: <ForkKnifeIcon />,
      title: t.gastroTitle,
      desc: t.gastroDesc
    },
    {
      icon: <MusicIcon />,
      title: t.cultureTitle,
      desc: t.cultureDesc
    },
    {
      icon: <HeartOutlineIcon />,
      title: t.hospTitle,
      desc: t.hospDesc
    }
  ];

  return (
    <section className="why-cali-section">
      <h2 className="why-cali-title">{t.whyCaliTitle}</h2>

      <div className="why-cali-grid">
        {features.map((feature, index) => (
          <div className="why-cali-item" key={index}>
            <div className="why-cali-icon">
              {feature.icon}
            </div>
            <h3 className="why-cali-item-title">{feature.title}</h3>
            <p className="why-cali-item-desc">{feature.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
